export enum TmListHeaderEvent {
    SearchTermChange = 'search-term-change',
}

export interface TmSearchTermPayload {
    value: string;
}

export type TmSearchTermChangeEvent = CustomEvent<TmSearchTermPayload>;
